import React from 'react'
import { Switch } from 'react-router-dom'
import { Permission, CIMSPage } from '@cims-online/shared'
import { ProtectedRoute } from 'components/ProtectedRoute'
import DocumentChecklists from './components/DocumentChecklists'
import TestingLabs from './components/TestingLabs'
import ConcreteTestSetTracker from './components/ConcreteTestSetTracker'
import Notifications from './components/Notifications'

const Concrete: React.FC = () => {
  return (
    <Switch>
      <ProtectedRoute
        path={[
          CIMSPage.ConcreteTestSets.recordPath,
          CIMSPage.ConcreteTestSets.projectPath,
        ]}
        permissions={Permission.ViewConcreteTestSet}
      >
        <ConcreteTestSetTracker />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.DocumentChecklists.projectPath}
        permissions={Permission.ViewDocumentChecklistItem}
      >
        <DocumentChecklists />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.ConcreteTestingLabs.projectPath}
        permissions={[Permission.ViewTestingLab, Permission.ViewLabTech]}
      >
        <TestingLabs />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.ConcreteNotifications.projectPath}
        permissions={Permission.ViewConcreteNotification}
      >
        <Notifications />
      </ProtectedRoute>
    </Switch>
  )
}

export default Concrete
